import script from "./Icon.vue?vue&type=script&setup=true&lang=js"
export * from "./Icon.vue?vue&type=script&setup=true&lang=js"

import "./Icon.vue?vue&type=style&index=0&id=8766f904&lang=css"

const __exports__ = script;

export default __exports__